import React from 'react';
import { Card, CardContent, CardActionArea, Box, Typography, Drawer } from '@mui/material';

import { InfoPage } from './';

import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';

import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import IconButton from '@mui/material/IconButton';

export default function WorkshopCard({ workshop, favourite, onToggleFavourite }) {

  if (!workshop.morning_session) {
    workshop.availableSpots.morning = '-'
  }

  if (!workshop.evening_session) {
    workshop.availableSpots.evening = '-'
  }

  if (!workshop.location) {
    workshop.location = '-';
  }

  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  }

  const fullyBooked =
    workshop.availableSpots.morning <= 0 &&
    workshop.availableSpots.evening <= 0;

  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: fullyBooked ? 'action.hover' : 'background.paper',
      }}
    >
      <Drawer
        anchor="bottom"
        open={open}
        onClose={() => setOpen(false)}
      >
        <Box
          sx={{
            height: '80vh',
            width: {
              xs: '90vw',
              md: '80vw',
            },
            margin: '0 auto',
            overflowY: 'auto',
          }}
        >
          {workshop && (
            <InfoPage
              workshop={workshop} onClose={() => setOpen(false)} onToggleFavourite={onToggleFavourite} favourite={favourite}
            />
          )}
        </Box>
      </Drawer>
      <CardActionArea onClick={toggleDrawer(true)} sx={{ flexGrow: 1 }}>
        <CardContent sx={{ flexGrow: 1 }}>
          <Typography gutterBottom sx={{ color: 'text.primary', fontSize: 14 }}>
            {workshop.location}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 1,
              mb: 1.5,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                flexGrow: 1,
                minWidth: 0,
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                minHeight: '3.3em',
                color: 'text.primary',
              }}
            >
              {workshop.name}
            </Typography>

            <IconButton
              onClick={(event) => {
                event.stopPropagation();
                onToggleFavourite(workshop.documentId);
              }}
              aria-label={
                favourite
                  ? 'Eemalda lemmikutest'
                  : 'Lisa lemmikutesse'
              }
              size="small"
            >
              {favourite ? (
                <FavoriteIcon color="error" />
              ) : (
                <FavoriteBorderIcon />
              )}
            </IconButton>
          </Box>
          <Box>
            <Typography variant="p" sx={{
              display: '-webkit-box',
              WebkitLineClamp: 4,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              minHeight: '5em',
              width: '100%',
              color: 'text.primary',
              mb: 1.5
            }}>
              {workshop.description}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              height: "100%"
            }}>
            <Typography component={'span'} variant="body2" sx={{
              display: '-webkit-box',
              WebkitLineClamp: 3,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              minHeight: '9em', color: 'text.primary', mb: 1.5
            }}>
              <Box display="flex" alignItems="center" gap={0.25} sx={{ mt: 1 }}><LightModeIcon /> 10.00-11.30 vabu kohti: {workshop.availableSpots.morning}</Box>
              <Box display="flex" alignItems="center" gap={0.25} sx={{ mt: 1 }}><DarkModeIcon /> 13.00-14.30 vabu kohti: {workshop.availableSpots.evening}</Box>
              <br />
              <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }}>
                {workshop.organization}
              </Typography>
            </Typography>
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}